import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';

@Component({
  selector: 'app-preview-seva-profile',
  templateUrl: './preview-seva-profile.component.html',
  styleUrls: ['./preview-seva-profile.component.scss']
})
export class PreviewSevaProfileComponent {
  
  constructor(private toastr: ToastrService, private api: SevaProfileService) { }

  applicantData:any 


  sevaPrn:any ={}

  ngOnInit(): void {
     this.sevaPrn = history?.state?.rowData?.SevaProfileDisplayUID;
    this.getApplicantData();
  }




  getApplicantData() {
    this.api.apiCall(`Applicant/sevaProfile/preview?SevaProfileDisplayUID=${ this.sevaPrn}`, 'GET').subscribe((response: any) => {
      if (response.Data && Object.keys(response.Data).length > 0) {
        // console.log("==============================", response.Data);
        this.applicantData =response.Data

        this.applicantData.EducationalAndWorkExperience = {
          UserEducation: response.Data.UserEducations,
          UserWorkExperience: response.Data.UserWorkExperiences
        };

    
      }
    })
  }

}
